import styled from "styled-components";

import { fonts, A } from "../shared";

export const Link = styled(A)`
    text-decoration: none;

    &,
    &:any-link {
        color: ${fonts.fontColors.light.primary};

        &:hover {
            color: ${fonts.fontColors.light.link};
            text-decoration: underline;
        }
    }
`;
